import React from 'react'
import { Container } from '@components/Globals'
import { Column, Row } from '@components/Common'
import ArticleBody from '@components/ArticleBody'
import ArticleHeader from '@components/ArticleHeader'
import { ArticleFootnote } from '@components/Footnote'

const EventsMain = props => {
  return (
    <Container fluid marginBottom={40}>
      <Row>
        <Column className="block">
          {props ? (
            <>
              <ArticleHeader {...props} />
              <ArticleBody {...props} />
              <ArticleFootnote content={props.content} />
            </>
          ) : (
            <div></div>
          )}
        </Column>
      </Row>
    </Container>
  )
}

export default EventsMain
